<template>
  <div>		
		<div class="pg-header">
			<div>
				<label class="title">排期模板</label>
			</div>
			<div class="algr">
				<div class="pg-nav">
					<i class="icon-home"></i>
					<!-- <router-link to="/">患者管理</router-link>| -->
					<span>系统管理</span>|
					<span class="active">排期模板</span>
				</div>
				<!-- <a class="back noline" @click="goBack">返回</a> -->
			</div>
		</div>
		
		<div class="table-wrap">
			<div class="search-bar">
				<label>模板名称
					<el-input size="small" placeholder="模板名称" clearable v-model.trim="filter.name" @keyup.enter.native="handleFilter(0)"></el-input>
				</label>
				<div style="display: inline-block;">科室
					<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.departmentId" @change="handleFilter(3, $event)">
						<el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
				<div style="display: inline-block;">模板类型
					<el-select size="small" filterable clearable placeholder="请选择" v-model="filter.autoState" @change="handleFilter(3, $event)">
						<el-option v-for="item in autoState" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
				<el-button size="mini" icon="el-icon-search" round @click="handleFilter(0)">搜索</el-button>
			</div>
			<div class="action-bar">
				<el-button type="primary" size="mini" round @click="showDlg">新增模板</el-button>
				<el-button type="primary" size="mini" round @click="showDrawer">模板库</el-button>

				<el-popconfirm confirmButtonText='删除' title="确定批量删除吗？" @confirm="delItem">
					<el-button slot="reference" type="danger" size="mini" round plain>批量删除</el-button>
				</el-popconfirm>
				
			</div>
			<el-table ref="multipleTable" header-cell-class-name="tab-cell" cell-class-name="tab-cell" border :data="list.data" v-loading="isLoading" @selection-change="selectionChange">
				<el-table-column fixed="left" :selectable="selectable" type="selection" width="55"></el-table-column>
				<el-table-column prop="name" label="模板名称" show-overflow-tooltip ></el-table-column>
				<el-table-column label="模板类型" show-overflow-tooltip>
					<template slot-scope="scope">
						{{
							{0:'系统默认模板',1: '自动排期模板',2:'手动排期模板'}[scope.row.autoState]
						}}
					</template>
				</el-table-column>
				<el-table-column prop="departmentName" label="科室" width="200" show-overflow-tooltip></el-table-column>
				<el-table-column prop="reviser" label="更新人" width="200"></el-table-column>
				<el-table-column prop="date" label="更新时间" width="200"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200">
					<template slot-scope="scope">
						<div class="tab-action">
							<el-tooltip content="查看" placement="top" :enterable="false"><router-link target='_blank' :to="{name: 'System/ScheduleTemplateView', query: {templateId: scope.row.id}}"><i class="icon-research"></i></router-link></el-tooltip>
							<!-- 待补充判断逻辑 -->
							<template v-if="scope.row.autoState != 0">
								<el-tooltip content="修改" placement="top" :enterable="false"><i class="el-icon-edit-outline" @click="showDlg(scope.row)"></i></el-tooltip>
								<el-popconfirm confirmButtonText='删除' title="确定删除吗？"  @confirm="delItem(scope.row)">
									<el-tooltip content="删除" slot="reference" placement="top" :enterable="false"><i class="el-icon-delete"></i></el-tooltip>
								</el-popconfirm>
							</template>
						</div>
					</template>
				</el-table-column>
			</el-table>	
			<div class="pagination">
				<el-row>
					<el-col :span="12">
						<div class="record">当前是第<span v-text="(filter.pageNumber-1)*filter.pageSize+1"></span>条至第<span v-text="(filter.pageNumber-1)*filter.pageSize+filter.pageSize"></span>数据</div>
						<div class="record">总计<span v-text="list.total"></span>条记录</div>
					</el-col>
					<el-col :span="12" style="text-align: right;">
						<el-pagination :disabled="isLoading" layout="sizes, prev, pager, next" :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"  prev-text="上一页" next-text="下一页" :current-page="list.current" :page-size="filter.pageSize" :total="list.total" @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
					</el-col>
				</el-row>
			</div>
		</div>

		<el-dialog :title="form.id > 0 ? '修改模板' : '新增模板'" width="760px" center :visible.sync="dlg.active" :close-on-click-modal="false">
			<el-form ref="form" label-width="120px" :rules="dlg.rules" :model="form">
				<el-form-item label="科室" prop="departmentId">
					<el-select filterable clearable v-model="form.departmentId" placeholder="请选择科室" >
						<el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="模板名称" prop="name">
					<el-input autocomplete="off" maxlength="50" :show-word-limit="true" v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="模板类型" prop="autoState">
					<el-select filterable clearable v-model="form.autoState" placeholder="请选择模板类型" >
						<el-option v-for="item in [{ id: 1, name: '自动排期模板' }, { id: 2, name: '手动排期模板' }]" :key="item.id" :label="item.name" :value="item.id"></el-option>
			
					</el-select>
				</el-form-item>
				<el-form-item v-if="form.autoState==1" label="疾病标签" prop="tagIds">
					<el-transfer :titles="['全部疾病标签', '已选疾病标签']" :props="{key: 'tagId', label: 'tagName' }" :data="diseaseTagList" v-model="form.tagIds"></el-transfer>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" :loading="isLoading" @click="saveTemplate">保 存</el-button>
			</div>
		</el-dialog>
		<el-drawer custom-class="knowledge" style="z-index: 1000;" title="模板库" size="1200px" :visible.sync="drawerVisible" :before-close="closeDlg">
			<TemplateLibrary ref="template" :visible="drawerVisible" @close="closeDlg" :deptList="deptList" @custom-event="loadList" />
		</el-drawer>
  </div>
	
			
</template>

<script>
// import HelloWorld from '@/components/HelloWorld.vue'
import mixin from '@/views/mixin';
import api from '@/service/api.js';
import dayjs from 'dayjs';
import TemplateLibrary from './components/templateLibrary'

export default {
	mixins: [mixin],
	components:{TemplateLibrary},
	data(){
		return {
			
			dlg: {
				active: false,
				rules: {
					name: {required: true, message: '请输入模板名', trigger: 'blur'},
					departmentId: {required: true, message: '请选择科室', trigger: 'change'},
					autoState: {required: true, message: '请选择模板类型', trigger: 'change'},
					tagIds : {required: true, message: '请选择疾病标签', trigger: 'change'}
				}
			},
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			},
			filter: {
				name: '',
				departmentId:'',
				pageNumber: 1,
				pageSize: 10,
				autoState:2
			},
			form: {
				name: '',
				departmentId: '',
				autoState: 2,
				tagIds:[]
			},
			templateList: [],		
			deptList: [],
			drawerVisible:false,
			diseaseTagList: undefined,
			autoState:[
				{
					id:0,
					name:'系统默认模板'
				},
				{
					id:1,
					name:'自动排期模板'
				},
				{
					id:2,
					name:'手动排期模板'
				}
			]
			
		}
	},
	created() {
		this.loadList();
		// 获取 科室下拉
		api.getDeptDropdown({}).then((res)=>{
			if (res.code == 1000 && res.data) {
				this.deptList = res.data;
			}
		})
		this.loadPatientAllTag();

	},
	methods: {
		selectable(row,index){
			if(row.autoState == 0){
				return false;
			}else{
				return true;
			}
		},
		async loadList() {
			this.isLoading = true;
			let res = await api.getScheduleTemplate(this.filter);
			if (res.code == 500) {return this.$router.push({name: 'Login', query: {r: location.href}});}
			this.list.total = +res.total;
			this.list.current = this.filter.pageNumber;
			this.list.pageSize = Math.ceil(this.list.total / this.filter.pageSize);
			if (res.data) {
				res.data.forEach((item)=>{
					item.date = dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss');
				})
				this.list.data = res.data;
			}
			this.isLoading = false;

		},
		// 疾病标签
		async loadPatientAllTag() {
			let res = await api.getPatientAllTag();
			if (res.code === 1000) {
				if (res.data.diseaseTagList) {
					this.diseaseTagList = res.data.diseaseTagList;
				}
			}
		},
		async showDlg(item) {
			console.log(item,'-----------item');
			this.dlg.active = true;
			if (item && item.id > 0) {
				let res=await api.getQueryByTemplateScheduleId({id:item.id});
				console.log(res,'-----------res');
				this.$nextTick(()=>{
					this.$refs['form'].resetFields();
					this.form.id = res.data.id;
					this.form.name = res.data.departmentName;
					this.form.departmentId = res.data.departmentId;
					this.form.tagIds =res.data.scheduleTagVos?.map(ite=> ite.tagId);
					this.form.autoState= res.data.autoState;
				
				});
			} else {
				this.form.id = 0;
				this.$nextTick(()=>{
					// this.diseaseTag =[]
					this.$refs['form'].resetFields();
				});
			}
		},
		showDrawer(){
			this.drawerVisible=true;
		},
		closeDlg() {
			this.dlg.active = false;
			this.drawerVisible=false;
			console.log(this.$refs['form'],'------------');
			this.$refs['form'].resetFields()
		},
		async saveTemplate() {
			let res;
			console.log(this.form,'========s');

			this.$refs['form'].validate(async (valid)=>{
				if (valid) {
					// this.form.tagIds = this.diseaseTag;

					if (this.form.id > 0) {
						res = await api.updateScheduleTemplate(this.form);
					} else {
						// 后端问题，不能带这参数
						this.form.id = null;
						res = await api.addScheduleTemplate(this.form);
					}
					if (res.code != 1000) {
						this.$message.error(res.message);
						return;
					}
					this.loadList();
					this.$message({message: '保存成功',type: 'success'});
					this.closeDlg();
				}
			})
		},
		async delItem(item) {
			let res;
			if (this.isLoading) { return;}
			
			this.isLoading = true;
			if (item && item.id > 0) {
				res = await api.delScheduleTemplate({ids: item.id});
			} else {
				// 批量删除
				if (this.multipleSelection.length == 0) {
					this.isLoading = false;
					return this.$message.warning('未选择任何数据');
				}
				res = await api.delScheduleTemplate({ids: this.multipleSelection.join(',')});
			}
			if (res.code != 1000) {
				this.isLoading = false;
				return this.$message.error(res.message);
			}
			this.isLoading = false;
			this.$message({message: '已删除',type: 'success'});
			this.loadList();
		},
		// 过滤条件 更改
		handleFilter(key, val) {
			this.filter.pageNumber = 1;
			this.loadList();
		},			
		handleSizeChange(v) {
			this.filter.pageSize = v;
			this.filter.pageNumber = 1;
			this.loadList();
		},
		handleCurrentChange(v) {
			this.filter.pageNumber = v;
			this.loadList();
		}
	}
}
</script>

<style lang="less" scoped>
@import '@/assets/style/var';
::v-deep .el-form-item {
    margin-bottom: 22px;
    display: flex;
    justify-content: center;
	.el-form-item__content{
		margin-left: 0 !important;
	}
}
</style>
